function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 47.2h48V0H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#525961",
  strokeWidth: 2,
  strokeLinejoin: "round",
  d: "M13.6 9.6L24 .8l10.4 8.8z"
}), /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#525961",
  strokeWidth: 2,
  mask: "url(#b)",
  d: "M.8 46.4h46.4V9.6H.8z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#525961",
  strokeWidth: 2,
  mask: "url(#b)",
  d: "M5.6 41.6h36.8V14.4H5.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.998 31.636l.835-.835a4.035 4.035 0 0 1 2.853-1.183h.693c1.07 0 2.097.426 2.853 1.183l.835.835",
  stroke: "#525961",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  mask: "url(#b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.599 23.983a1.009 1.009 0 1 0 0 2.018 1.009 1.009 0 0 0 0-2.018M26.402 23.983a1.009 1.009 0 1 0 0 2.018 1.009 1.009 0 0 0 0-2.018",
  fill: "#525961",
  mask: "url(#b)"
}));

function SvgNoImageIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 -1 48 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImageIcon);
export default __webpack_public_path__ + "static/media/noImageIcon.b6b9423775199a160a1806bac01d4e35.svg";
export { ForwardRef as ReactComponent };